<template>
  <div>
      <div class="home">
        <div class="banner">
          <swiper class="swiper h-100" :options="swiperOption">
            <swiper-slide v-for="(item,index) in banner" :key="index">
              <div class="mask"></div>
              <img :src="item" class="w-100 h-100 object-fit-cover">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev d-none" slot="button-prev"></div>
            <div class="swiper-button-next d-none" slot="button-next"></div>
          </swiper>
          <p class="text px-3 px-lg-5 letterA">FUSION OF SPACE</p>
        </div>
        <div class="indexPro py-5">
          <div class="py-lg-4">
            <div class="container-lg px-3">
              <div class="title d-flex justify-content-between">
                <h2 class="mb-0 fw-bold">PROJECTS</h2>
                <router-link to="/projects/0" class="d-flex align-items-center">
                  <i class="bi bi-arrow-right-short fs-4"></i>
                  <span class="ps-2">more</span>
                </router-link>
              </div>
            </div>
            <div class="container-fluid px-3 px-md-2 mt-4 mt-lg-5">
              <ul class="row row-cols-1 row-cols-md-2 g-3 g-md-2">
                <li class="col" v-for="(item,index) in filteredProjects" :key="index">
                  <!-- <a href="javascript:" class="d-block" @click="showDetail(item.picture,item.video)"> -->
                  <router-link :to="{path: '/projects/detail/' + item.id,query: {type: item.curType}}" @click="getInfo(item.cntitle)" class="d-block">
                    <div class="pic h-100 overflow-hidden"><img :src="item.poster" class="w-100 h-100 object-fit-cover time05"></div>
                    <div class="mask time05"></div>
                    <dl class="text mb-0 px-3 px-lg-4">
                      <dt>{{item.cntitle}}<span class="ps-2">{{item.place}}</span></dt>
                      <dd class="mb-0">{{item.title}}</dd>
                    </dl>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="indexAbout pb-5">
          <div class="pb-lg-4">
            <div class="container-lg px-3">
              <div class="title d-flex justify-content-between">
                <h2 class="mb-0 fw-bold">ABOUT</h2>
                <router-link to="/about" class="d-flex align-items-center">
                  <i class="bi bi-arrow-right-short fs-4"></i>
                  <span class="ps-2">more</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="container-fluid px-3 px-md-2 mt-4 mt-lg-5">
            <div class="row row-cols-1 row-cols-md-2 gx-3 gy-4 g-lg-2">
              <div class="col">
                <div class="lh-lg text">
                  <div class="position-relative" v-html="profile.content"></div>
                </div>
              </div>
              <div class="col">
                <div class="pic mt-2" v-for="(item,index) in profile.picture" :key="index">
                  <img :src="item" class="w-100 h-100 object-fit-cover">
                </div>  
              </div>
            </div>
          </div>
        </div>
      </div>
<!-- 
      <PicDetail :pic='selectPic' :video='selectVideo' ref="picModalView"/> -->
  </div>
</template>


<script>
import axios from '@/axios-auth'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import "swiper/css/swiper.min.css";
// import PicDetail from '@/components/picDetail'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      banner:[
        "/static/images/banner1.jpg",
        "/static/images/banner2.jpg",
        "/static/images/banner3.jpg",
        "/static/images/banner4.jpg"
      ],

      swiperOption: {
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          autoplay: {
            delay: 5000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
      },

      projectLists:[],
      profile:''
    }
  },
  created(){
    axios.get('/projects.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            response.data.forEach((project) => {
              project.list.forEach((item) => {
                this.projectLists.push(item)
              })
            })
          }
        })
    axios.get('/about.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            this.profile = response.data.profile
          }
        })
  },
  methods:{

  },
  computed:{
    filteredProjects(){
      let projects = []
      this.projectLists.forEach((project) => {
        if(project.cntitle === '横岗区高华眼镜厂员工宿舍' || project.cntitle === '龙岗区高华眼镜厂' || project.cntitle === '建国南路办公大厦'|| project.cntitle === '森林路KTV大楼'){
          projects.push(project)
          
        } 
      })
      return projects
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner{ height: 400px; position: relative;}
  .banner .text{ width: 100%; position: absolute; z-index: 5; left: 50%; top: 50%; transform: translateX(-50%) translateY(-60%); color: #fff; font-size: 36px; font-weight: bold; text-align: center;}
  .banner .mask{ background-color: rgba(0, 0, 0, .3); position: absolute; left: 0; right: 0; top: 0; bottom: 0;}
  .swiper-pagination{ color: #fff; bottom: 2vh; font-size: 18px;}

  .indexPro li a{ position: relative; height: 250px;}
  .indexPro .text{ position: absolute; left: 0; right: 0; bottom: 15px; color: #fff;}
  .indexPro dt{ font-size: 14px; font-weight: normal;}
  .indexPro dd{ font-size: 12px;}
  .indexPro .mask{ background-color: rgba(0, 0, 0, .3); position: absolute; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%); width: 100%; height: 100%;}

  .indexAbout .text{ color: #666;}
  .indexAbout .pic:first-child{ margin-top: 0 !important;}
  .indexAbout .pic{ height: 250px;}

  @media (min-width: 576px) {
    .indexPro li a{ height: 350px;}
  }

  @media (min-width: 768px) {
      /* .indexPro li a{ height: 250px;} */
  }

  @media (min-width: 992px) {
    .banner{ height: calc(100vh - 80px);}
    .banner .text{ font-size: 80px;}
    .indexPro li a{ height: 450px;}
    .indexPro .text{ bottom: 30px;}
    .indexPro li a:hover .mask{ opacity: 0;}
    .indexPro li a:hover img{transform:scale(1.05) ;}

    .indexAbout .text{ padding-left:calc((100vw - 960px) / 2 + .5rem); padding-right: 5%; position: sticky; left: 0; top: 110px;}
    .indexAbout .pic{ height: 350px;}

  }

  @media (min-width: 1200px) {
    .indexAbout .text{ padding-left:calc((100vw - 1140px) / 2 + .5rem);}
  }

  @media (min-width: 1400px) {
    .indexPro li a{ height: 635px;}
    .indexPro dt{ font-size: 18px;}
    .indexPro dd{ font-size: 18px;}

    .indexAbout .text{ padding-left:calc((100vw - 1320px) / 2 + .5rem);}
    .indexAbout .pic{ height: 500px;}


  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue